import React from "react";
import { map } from "lodash";
import { QRProps } from "@/contexts/QREditorContext/types";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import {
  PreviewHeroHeader,
  PreviewSocialNetworks,
  InitPreviewSocialLogos,
} from "@/features/previews/shared/components";
import { useListLinksData } from "./hooks/useListLinksData";
import { LinksContainer } from "./components/LinksContainer";
import { LinkItem } from "./components/LinkItem";
import "./ListLinksTemplate.scss";

export const ListLinksTemplate = (props: QRProps<"listoflinks">) => {
  const { data, isInitialPreview } = useListLinksData(props);
  if (!data) {
    return null;
  }

  const { title, description, links, logoUrl, socialNetworks, themeColor, socialLogos } = data;

  return (
    <PhoneLayout
      page="links"
      dataQA="preview-links-container"
      backgroundColor={themeColor?.backgroundColor}
      isInitPreview={isInitialPreview}
      hasIncludeBrowser
    >
      <div className="list-links-template">
        <PreviewHeroHeader
          variant="links"
          logoUrl={logoUrl}
          title={title}
          subtitle={description}
          isInitialPreview={isInitialPreview}
          logoAlt="link preview"
        />

        {links?.length > 0 && (
          <LinksContainer>
            {map(links, (link, idx) => (
              <LinkItem
                key={idx}
                text={link.linkText}
                url={link.linkUrl}
                imageUrl={link.linkImageUrl}
                buttonColor={themeColor?.buttonColor}
              />
            ))}
          </LinksContainer>
        )}

        {isInitialPreview && socialLogos && (
          <div className="list-links-template__init-logos">
            <InitPreviewSocialLogos
              type="listoflinks"
              socialLogos={socialLogos}
            />
          </div>
        )}

        {socialNetworks && socialNetworks.length > 0 && (
          <div className="list-links-template__social-networks">
            <PreviewSocialNetworks
              networks={socialNetworks}
              variant="links"
              center
            />
          </div>
        )}
      </div>
    </PhoneLayout>
  );
};
